import {crToPb} from './cr-to-pb';
import {getAbilityMod} from './get-ability-mod';

export function toMonsterInitiative(dex: number, cr?: string | null, initiativeProfBonus?: number | null) {
	let initBonus = parseInt(getAbilityMod(dex).replace('−', '-'), 10);
	if (initiativeProfBonus) {
		initBonus += crToPb(cr) * initiativeProfBonus;
	}

	let initPassive = 10 + initBonus;

	if (initBonus == null || initPassive == null) return '—';

	const sign = initBonus >= 0;
	return `${sign ? '+' : '−'}${Math.abs(initBonus).toString()} (${initPassive})`;
}
